// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/member.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * A user who belongs to a workspace with a specific role.
 *
 * @generated from message omnios.v1.WorkspaceMember
 */
export const WorkspaceMember = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.WorkspaceMember",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "avatar_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "joined_at", kind: "message", T: Timestamp },
  ],
);

/**
 * An email-based invitation that has not yet been accepted.
 *
 * @generated from message omnios.v1.WorkspaceInvite
 */
export const WorkspaceInvite = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.WorkspaceInvite",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "invited_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
    { no: 11, name: "expires_at", kind: "message", T: Timestamp },
  ],
);

/**
 * A shareable link that lets anyone join with a preset role.
 *
 * @generated from message omnios.v1.WorkspaceInviteLink
 */
export const WorkspaceInviteLink = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.WorkspaceInviteLink",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "max_uses", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 7, name: "use_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
    { no: 11, name: "expires_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.ListMembersRequest
 */
export const ListMembersRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListMembersRequest",
  () => [
    { no: 1, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListMembersResponse
 */
export const ListMembersResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListMembersResponse",
  () => [
    { no: 1, name: "members", kind: "message", T: WorkspaceMember, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.UpdateMemberRoleRequest
 */
export const UpdateMemberRoleRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateMemberRoleRequest",
  () => [
    { no: 1, name: "member_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.RemoveMemberRequest
 */
export const RemoveMemberRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RemoveMemberRequest",
  () => [
    { no: 1, name: "member_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.UploadMemberAvatarRequest
 */
export const UploadMemberAvatarRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UploadMemberAvatarRequest",
  () => [
    { no: 1, name: "data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "mime_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.InviteByEmailRequest
 */
export const InviteByEmailRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.InviteByEmailRequest",
  () => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListInvitesRequest
 */
export const ListInvitesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListInvitesRequest",
  [],
);

/**
 * @generated from message omnios.v1.ListInvitesResponse
 */
export const ListInvitesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListInvitesResponse",
  () => [
    { no: 1, name: "invites", kind: "message", T: WorkspaceInvite, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.CancelInviteRequest
 */
export const CancelInviteRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CancelInviteRequest",
  () => [
    { no: 1, name: "invite_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateInviteLinkRequest
 */
export const CreateInviteLinkRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateInviteLinkRequest",
  () => [
    { no: 1, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "max_uses", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.ListInviteLinksRequest
 */
export const ListInviteLinksRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListInviteLinksRequest",
  [],
);

/**
 * @generated from message omnios.v1.ListInviteLinksResponse
 */
export const ListInviteLinksResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListInviteLinksResponse",
  () => [
    { no: 1, name: "links", kind: "message", T: WorkspaceInviteLink, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.RevokeInviteLinkRequest
 */
export const RevokeInviteLinkRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RevokeInviteLinkRequest",
  () => [
    { no: 1, name: "link_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.AcceptInviteLinkRequest
 */
export const AcceptInviteLinkRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AcceptInviteLinkRequest",
  () => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.MySubscription
 */
export const MySubscription = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.MySubscription",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "plan_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "plan_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "period", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "seat_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "current_period_start", kind: "message", T: Timestamp },
    { no: 8, name: "current_period_end", kind: "message", T: Timestamp },
    { no: 9, name: "trial_end", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.MyUsageMetric
 */
export const MyUsageMetric = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.MyUsageMetric",
  () => [
    { no: 1, name: "metric_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "metric_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "grant_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "included_quantity", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "current_usage", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message omnios.v1.AvailablePlan
 */
export const AvailablePlan = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AvailablePlan",
  () => [
    { no: 1, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "trial_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "monthly_base_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "monthly_per_seat_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "included_seats", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.GetMySubscriptionRequest
 */
export const GetMySubscriptionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetMySubscriptionRequest",
  [],
);

/**
 * @generated from message omnios.v1.GetMySubscriptionResponse
 */
export const GetMySubscriptionResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetMySubscriptionResponse",
  () => [
    { no: 1, name: "subscription", kind: "message", T: MySubscription },
  ],
);

/**
 * @generated from message omnios.v1.GetMyUsageRequest
 */
export const GetMyUsageRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetMyUsageRequest",
  [],
);

/**
 * @generated from message omnios.v1.GetMyUsageResponse
 */
export const GetMyUsageResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetMyUsageResponse",
  () => [
    { no: 1, name: "metrics", kind: "message", T: MyUsageMetric, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetAvailablePlansRequest
 */
export const GetAvailablePlansRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetAvailablePlansRequest",
  [],
);

/**
 * @generated from message omnios.v1.GetAvailablePlansResponse
 */
export const GetAvailablePlansResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetAvailablePlansResponse",
  () => [
    { no: 1, name: "plans", kind: "message", T: AvailablePlan, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.BillingDetails
 */
export const BillingDetails = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BillingDetails",
  () => [
    { no: 1, name: "billing_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "company_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "address_line1", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "address_line2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "postal_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "tax_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetBillingDetailsRequest
 */
export const GetBillingDetailsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetBillingDetailsRequest",
  [],
);

/**
 * @generated from message omnios.v1.GetBillingDetailsResponse
 */
export const GetBillingDetailsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetBillingDetailsResponse",
  () => [
    { no: 1, name: "details", kind: "message", T: BillingDetails },
  ],
);

/**
 * @generated from message omnios.v1.UpdateBillingDetailsRequest
 */
export const UpdateBillingDetailsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateBillingDetailsRequest",
  () => [
    { no: 1, name: "details", kind: "message", T: BillingDetails },
  ],
);

/**
 * @generated from message omnios.v1.UpdateBillingDetailsResponse
 */
export const UpdateBillingDetailsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateBillingDetailsResponse",
  () => [
    { no: 1, name: "details", kind: "message", T: BillingDetails },
  ],
);

